import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=43425954"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43425954')) {
      api.createRecord('43425954', component.options)
    } else {
      api.reload('43425954', component.options)
    }
    module.hot.accept("./StudentForm.vue?vue&type=template&id=43425954", function () {
      api.rerender('43425954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/manytomany/StudentForm.vue"
export default component.exports